module.exports = __webpack_public_path__ + "static/img/18.b210111.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutUs/companys/18.png
// module id = Y3ME
// module chunks = 1